<p-toast [style]="{marginTop: '80px'}"></p-toast>
 <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<h6 class="prd-h6"> Appeals Users </h6>
<div class="card" >
    <div class="card-body" *ngIf = 'displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='!this.displayState.userDiv && !this.displayState.workingDiv' >
  <div class="col-md-2 offset-1">
      <button class="btn btn-sm btn-link" (click)="newUser()" [disabled]="userType === 'Read-Only' || userType === 'Assessor'">New User</button>
  </div>
  <div class="col-md-4 offset-md-5">
    <label for="chkActiveOnly" style="font-weight: bold;">Active Users Only?</label>
    <input id="chkActiveOnly" type="checkbox" [(ngModel)]='activeUserOnly' class="offset-md-1" (change)="filterOnStatus()">
  </div>
</div>

<div class="row" *ngIf = 'displayState.gridDiv && !this.displayState.workingDiv'>
  <div class="col-md-10 offset-1">
    <p-table [value]="appealsUserList" [scrollable]="true" scrollHeight="540px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:smaller">
              <th style="width: 10%" >&nbsp;</th>
              <th [pSortableColumn]="'emailAddress'" style="width: 20%" >
                  UserName
                  <p-sortIcon [field]="'emailAddress'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'firstName'" style="width: 15%">
                  First Name
                  <p-sortIcon [field]="'firstName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'lastName'" style="width: 15%">
                Last Name
                <p-sortIcon [field]="'lastName'"></p-sortIcon>
            </th>
              <th [pSortableColumn]="'userType'" style="width: 15%">
                User Type
                <p-sortIcon [field]="'userType'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'lastLoginDt'" style="width: 10%">
                Last Login Dt
                <p-sortIcon [field]="'lastLoginDt'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'isActive'" style="width: 10%">
                Active
                <p-sortIcon [field]="'isActive'"></p-sortIcon>
              </th>
              <th style="width: 10%" >&nbsp;</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
          <tr style="font-size: small;">
              <td style="width: 10%">
                  <button class='btn btn-sm btn-link' (click)="onSelect(user)" [disabled]="userType === 'Read-Only' || userType === 'Assessor'">Select</button>
              </td>
              <td style="width: 20%">{{user.emailAddress }}</td>
              <td style="width: 15%">{{user.firstName}}</td>
              <td style="width: 15%">{{user.lastName}}</td>
              <td style="width: 15%">{{user.userType}}</td>
              <td style="width: 10%">{{user.lastLoginDt | date:"MM/dd/yyyy HH:mm"}}</td>
              <td style="width: 10%"> <input type="checkbox" [(ngModel)]='user.isActive' disabled> </td>
              <td style="width: 10%">
                <button class='btn btn-sm btn-link' (click)="deleteUser(user)" [disabled]="!isDeveloper()">Delete</button>
            </td>

          </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="row" *ngIf='displayState.editUserDiv'>
    <div class="card bg-light col-md-6 offset-3">
        <div class="card-body">
            <div class="form-row">
                <label for="email" class="col-md-2 col-form-label prd-label">E-mail Address</label>
                <input type="text" class="form-control col-md-8 prd-required" id="email" [(ngModel)]="myUser.emailAddress">
            </div>
            <br />
           <div class="form-row">
                <!-- First Name -->
                <label for="firstName" class="col-md-2 col-form-label prd-label">First Name</label>
                <input type="text" class="form-control col-md-8" id="firstName" [(ngModel)]="myUser.firstName">
            </div>
            <br />
            <div class="form-row">
                <!-- Last Name -->
                <label for="lastName" class="col-md-2 col-form-label prd-label">Last Name</label>
                <input type="text" class="form-control col-md-8 prd-required" id="lastName" [(ngModel)]="myUser.lastName">
            </div>
            <br />
            <div class="form-row">
                <!-- Type -->
                <label for="userType" class="col-md-2 col-form-label prd-label">Role</label>
                <div class="col-md-1">
                    <select [(ngModel)] = 'myUser.userType' id="userType" class="prd-required">
                      <option></option>
                      <option [ngValue]="usrType" *ngFor="let usrType of userTypeList" >{{ usrType }}</option>
                  </select>
                  </div>
            </div>
            <br />
            <div class="form-row">
                <!-- Active Flag -->
                <label for="isActive" class="col-sm-2 col-form-label prd-label">Active?</label>
                <input id="isActive" type="checkbox" class="form-control col-sm-2" [(ngModel)]="myUser.isActive">
            </div>
            <br />
            <div class="form-row">
                <!-- Buttons -->
                <button class="btn btn-success offset-4" (click)="saveUser()" [disabled] = "displayState.saveDisabled" >Save</button>
                <button class="btn btn-warning offset-1" (click)="cancelEntry()">Cancel</button>
            </div>
        </div>
    </div>
</div>
